import { useAccount } from 'wagmi'

interface UseSignerProps {
  isConnected: boolean
}

/**
 * Small hook that connects to use connectSigner to setup contracts
 */
export const useSigner = (): UseSignerProps => {
  const { isConnected } = useAccount()

  return { isConnected }
}
